import { PLATFORM } from 'aurelia-pal';
var ENGINE_MODULES = {
    'dialogs/ticket-dialog': PLATFORM.moduleName('app/styles/client/render-engine/dialogs/ticket-dialog'),
    'dialogs/choose-numbers-dialog': PLATFORM.moduleName('app/styles/client/render-engine/dialogs/choose-numbers-dialog'),
    'dialogs/instant-game-dialog': PLATFORM.moduleName('app/styles/client/render-engine/dialogs/instant-game-dialog'),
    'dialogs/confirm-dialog': PLATFORM.moduleName('app/styles/client/render-engine/dialogs/confirm-dialog'),
    'common/client-details-dialog': PLATFORM.moduleName('app/styles/client/render-engine/common/client-details-dialog'),
};
export function clientComponentModuleId(relPath) {
    return ENGINE_MODULES[relPath];
}
